import React from 'react';

import * as S from './styles';
import { MenuListSectionProps } from './types';

const MenuListSection: React.FunctionComponent<MenuListSectionProps> = (
  props,
) => {
  const { children, headingProps = {}, groupProps = {}, title } = props;

  return (
    <S.MenuListSectionRoot {...groupProps}>
      <S.TitleContainer {...headingProps}>
        <S.Title>{title}</S.Title>
      </S.TitleContainer>
      {children}
    </S.MenuListSectionRoot>
  );
};

export default MenuListSection;
